import React from 'react';
import { useMediaQuery } from 'react-responsive';
import TopBar from '../../../hooks/TopBar';
import AdmProfileSection from './AdminProfileSection';
import AdmPasswordSection from './AdminPasswordSection';
import AdmSecuritySection from './AdminSecuritySection';

const cardStyle = {
  border: '1px solid #ddd',
  background: '#fff',
  padding: '16px',
  borderRadius: '12px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const AdmAccountLayout = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <TopBar />

      <div
        className="container-fluid py-3"
        style={{
          height: !isMobile ? 'calc(100vh - 60px)' : 'auto',
          overflowY: isMobile ? 'auto' : 'hidden',
          backgroundColor: '#FF9B45',
        }}
      >
        <div
          className={`d-flex flex-column ${!isMobile ? 'flex-md-row' : ''} gap-3`}
          style={{ height: !isMobile ? '100%' : 'auto' }}
        >
          {isMobile && (
            <div className="w-100">
              <div style={{ ...cardStyle }}>
                <AdmProfileSection />
              </div>
              <div className="mt-3" style={{ ...cardStyle }}>
                <AdmPasswordSection />
              </div>
              <div className="mt-3" style={{ ...cardStyle }}>
                <AdmSecuritySection />
              </div>
            </div>
          )}

          {!isMobile && (
            <>
              {/* Profile Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <AdmProfileSection />
                </div>
              </div>

              {/* Password Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <AdmPasswordSection />
                </div>
              </div>

              {/* Security Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <AdmSecuritySection />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AdmAccountLayout;
